import React, {useEffect, useState} from "react";

import axios, {formUrlEncodedHeaders} from "config/axiosConfig";
import dateFormat, { masks } from "dateformat";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {Pagination} from "../util/Pagination";
import qs from "qs";

export default function Main() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);

    const [categories, setCategories] = useState([]);
    const [industries, setIndustries] = useState([]);

    const [inputSearchKeyword, setInputSearchKeyword] = useState('');
    const [inputCategories, setInputCategories] = useState([]);
    const [inputIndustries, setInputIndustries] = useState([]);
    const [inputRegion, setInputRegion] = useState('');
    const [inputCeoAge, setInputCeoAge] = useState('');
    const [inputFourMajorInsurance, setInputFourMajorInsurance] = useState('');
    const [inputPinnedOnly, setInputPinnedOnly] = useState(false);

    const location= useLocation();
    const navigate = useNavigate();

    const page = searchParams.get('page') || "1";
    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }
    const requestSearch = (e) => {
        const params = {};
        params.page = page;
        params.keyword = inputSearchKeyword;
        params.categories = inputCategories;
        params.industries = inputIndustries;
        params.region = inputRegion;
        params.ceoAge = inputCeoAge;
        params.fourMajorInsurance = inputFourMajorInsurance;
        if (inputPinnedOnly === true) {
            params.pinned = true;
        }

        axios.get(`/admin/policy-support/projects`, { params: params })
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    }

    useEffect(() => {
        axios.get(`/admin/policy-support/categories`)
            .then((res) => {
                setCategories(res.data);
            });
        axios.get(`/admin/policy-support/industries`)
            .then((res) => {
                setIndustries(res.data);
            });
    }, []);

    useEffect(() => {
        requestSearch();
    }, [page]);

    const handleInputCategory = (e) => {
        if (e.target.checked === true) {
            setInputCategories([...inputCategories, e.target.value]);
        } else {
            const removedNames = inputCategories.filter((name, offset) => name !== e.target.value);
            setInputCategories(removedNames);
        }
    }

    const handleInputIndustry = (e) => {
        if (e.target.checked === true) {
            setInputIndustries([...inputIndustries, e.target.value]);
        } else {
            const removedNames = inputIndustries.filter((name, offset) => name !== e.target.value);
            setInputIndustries(removedNames);
        }
    }

    const handleInputIndustryCheckAll = (e) => {
        if (inputIndustries.length === industries.length) {
            setInputIndustries([]);
        } else {
            const industryNames = industries.map(item => item.name);
            setInputIndustries(industryNames);
        }
    }

    const updateVisible = (id, visible) => {
        if (id === null) { return; }
        const newContents = contents.map((contentItem, i) =>
            contentItem.id === id
                ? { ...contentItem, visible: visible }
                : contentItem
        );
        setContents(newContents);

        let params = {visible: visible};
        axios.put(`/admin/policy-support/projects/${id}/visible`, params, formUrlEncodedHeaders)
            .then((res) => {

            })
            .catch((err) => {
                const newContents = contents.map((contentItem, i) =>
                    contentItem.id === id
                        ? { ...contentItem, visible: !visible }
                        : contentItem
                );
                setContents(newContents);
            });
    };

    const displaySupportType = (supportType) => {
        switch (supportType) {
            case "MUST_KNOW_FOR_RUNNING": return "장사중 챙길 것들";
            case "SUPPORT_PROGRAMS": return "지원사업 모아보기";
            case "BUSINESS_ISSUES": return "자영업 이슈";
            case "BEGINNER_GUIDE": return "초보사장님 필독";
        }
    }

    const requestDelete = (id) => {
        if(window.confirm("정말 삭제하시겠습니까?")) {
            axios.delete(`/admin/policy-support/projects/` + id)
                .then((res) => {
                    document.location.reload();
                });
        }
    }

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">자영업 정보센터</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="form-group row">
                                                <label htmlFor="searchText"
                                                       className="col-sm-1 col-form-label">검색어</label>
                                                <div className="col-sm">
                                                    <input type="text" className="form-control" id="searchText"
                                                        onChange={ e => setInputSearchKeyword(e.target.value) }
                                                           value={inputSearchKeyword} />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-sm-1 col-form-label">업종</label>
                                                {
                                                    industries && industries.map(item => {
                                                        return (
                                                            <div className="form-check" style={{marginLeft: "20px"}}>
                                                                <input id={item.name} className="form-check-input"
                                                                       type="checkbox"
                                                                       checked={inputIndustries.includes(item.name)}
                                                                       onChange={handleInputIndustry}
                                                                       value={item.name}
                                                                />
                                                                <label className="form-check-label"
                                                                       style={{marginLeft: "-3px"}}
                                                                       htmlFor={item.name}>{item.name}</label>
                                                            </div>
                                                        )
                                                    })
                                                }

                                                <div className="form-check" style={{marginLeft: "20px"}}>
                                                    <input id="industryCheckAll" className="form-check-input"
                                                           type="checkbox"
                                                           checked={inputIndustries.length === industries.length}
                                                           onChange={handleInputIndustryCheckAll}
                                                    />
                                                    <label className="form-check-label"
                                                           style={{marginLeft: "-3px"}}
                                                           htmlFor="industryCheckAll">모두선택</label>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label htmlFor="tagText"
                                                       className="col-sm-1 col-form-label">선택</label>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>지역</label>
                                                <div className="col-2">
                                                    <select className="form-control"
                                                            style={{width: '200px', marginRight: '10px'}}
                                                            onChange={e => setInputRegion(e.target.value)}
                                                            value={inputRegion}>
                                                    <option value="">미선택</option>
                                                        <option value="CAPITAL">수도권</option>
                                                        <option value="NO_CAPITAL">수도권 외</option>
                                                    </select>
                                                </div>

                                                <label className="col-sm-auto col-form-label">대표자 나이</label>
                                                <div className="col-2">
                                                    <select className="form-control"
                                                            style={{width: '200px', marginRight: '10px'}}
                                                            onChange={ e => setInputCeoAge(e.target.value) }
                                                            value={inputCeoAge}>
                                                        <option value="">미선택</option>
                                                        <option value="THIRTY_NINE_BELOW">만 39세 이하</option>
                                                        <option value="THIRTY_NINE_OVER">만 39세 초과</option>
                                                    </select>
                                                </div>

                                                <label className="col-sm-auto col-form-label">4대보험 신고여부</label>
                                                <div className="col-2">
                                                    <select className="form-control"
                                                            style={{width: '200px', marginRight: '10px'}}
                                                            onChange={ e => setInputFourMajorInsurance(e.target.value) }
                                                            value={inputFourMajorInsurance}>
                                                        <option value="">미선택</option>
                                                        <option value="true">여</option>
                                                        <option value="false">부</option>
                                                    </select>
                                                </div>

                                                <label className="col-sm-auto col-form-label" htmlFor="pinnedOnly">인기글 우선 노출만</label>
                                                <div className="col-sm-auto" style={{ display: 'flex', alignItems: 'center', marginBottom: '22px' }}>
                                                    <div className="form-check">
                                                        <input id="pinnedOnly" className="form-check-input" type="checkbox"
                                                               checked={inputPinnedOnly}
                                                               onChange={ e => setInputPinnedOnly(e.target.checked) } />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row" style={{marginTop: '30px', marginBottom: '10px'}}>
                                                <div style={{margin: "0 auto"}}>
                                                    <button type="button" className="btn btn-outline-primary" onClick={requestSearch}>
                                                        검색
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card" style={{marginTop: "70px"}}>
                                        <div className="card-header">
                                            <div className="input-group">
                                                <button type="button" className="btn btn-outline-dark"
                                                        style={{float: 'right'}}
                                                        onClick={e => navigate('/page/policy-support/keyword')}>
                                                    키워드 관리
                                                </button>
                                                <button type="button" className="btn btn-outline-dark"
                                                        style={{float: 'right'}}
                                                        onClick={ e => navigate('/page/policy-support/edit')}>
                                                    사업추가
                                                </button>
                                            </div>
                                        </div>


                                        <div className="card-body table-responsive p-0">
                                            <table className="table table-hover text-nowrap" style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>id</th>
                                                    <th>지원유형</th>
                                                    <th>제목</th>
                                                    <th>일정</th>
                                                    <th>업종</th>
                                                    <th>지역</th>
                                                    <th>대표자 나이</th>
                                                    <th>4대보험 신고여부</th>
                                                    <th>태그</th>
                                                    <th>노출여부</th>
                                                    <th>조회수</th>
                                                    <th>좋아요 수</th>
                                                    <th>아쉬워요 수</th>
                                                    <th>찜 수</th>
                                                    <th>삭제</th>
                                                    <th>상세보기</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents.map((item, index) => {
                                                        const startDate = item.startDate && dateFormat(item.startDate, 'yy.mm.dd');
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{displaySupportType(item.supportType)}</td>
                                                                <td>{item.title}</td>
                                                                <td>{startDate} ~ {item.endDate}</td>
                                                                <td>
                                                                    {
                                                                        item.industries && item.industries.map(industry => {
                                                                            return (
                                                                                <div>{industry.name}</div>
                                                                            )
                                                                        })
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        item.region === 'CAPITAL'
                                                                            ? <div>수도권</div>
                                                                            : (item.region === 'NO_CAPITAL'
                                                                                    ? <div>수도권 외</div>
                                                                                    : <div>-</div>
                                                                            )
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        item.ceoAge === 'THIRTY_NINE_BELOW'
                                                                            ? <div>39세 이하</div>
                                                                            : (item.ceoAge === 'THIRTY_NINE_OVER'
                                                                                    ? <div>39세 초과</div>
                                                                                    : <div>-</div>
                                                                            )
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        item.fourMajorInsurance === true
                                                                            ? <div>여</div>
                                                                            : (item.fourMajorInsurance === false
                                                                                    ? <div>부</div>
                                                                                    : <div>-</div>
                                                                            )
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        item.tags && item.tags.map(tag => {
                                                                            return (
                                                                                <div>#{tag.name}</div>
                                                                            )
                                                                        })
                                                                    }
                                                                </td>
                                                                <td>
                                                                    <td width="110px">
                                                                        <div className="form-group row">
                                                                            <div className="custom-control custom-switch custom-switch-on-success">
                                                                                <input type="checkbox"
                                                                                       className="custom-control-input"
                                                                                       id={"customSwitch" + index}
                                                                                       checked={item.visible}
                                                                                       onChange={ e => {
                                                                                           updateVisible(item.id, e.target.checked);
                                                                                       }}
                                                                                />
                                                                                <label className="custom-control-label" htmlFor={"customSwitch" + index}>
                                                                                    {
                                                                                        item.visible
                                                                                            ? <span>노출(ON)</span>
                                                                                            : <span>노출(OFF)</span>
                                                                                    }
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </td>
                                                                <td>{item.readCount}</td>
                                                                <td>{item.likeCount}</td>
                                                                <td>{item.disLikeCount}</td>
                                                                <td>{item.favoriteCount}</td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-dark"
                                                                            style={{marginLeft: '5px'}}
                                                                            onClick={ e => requestDelete(item.id) }>
                                                                        삭제
                                                                    </button>
                                                                </td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-dark"
                                                                            style={{marginLeft: '5px'}}
                                                                            onClick={e => navigate('/page/policy-support/edit?id=' + item.id)}>
                                                                        보기
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    {
                                        paginationDto && <Pagination pager={paginationDto} setPage={setPage}/>
                                    }

                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}